import { render, staticRenderFns } from "./my-profile-dialog.component.vue?vue&type=template&id=3f606c2b"
import script from "./my-profile-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./my-profile-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports